module.exports = __webpack_public_path__ + "static/media/checkpoint_white.9cfab27d.png";